import React from 'react';

interface EmptyStateProps {
  icon?: React.ReactNode;
  message: string;
  sub?: string;
}

export function EmptyState({ icon, message, sub }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      {icon && <div className="text-gray-600 mb-3">{icon}</div>}
      <p className="text-sm font-medium text-gray-400">{message}</p>
      {sub && <p className="text-xs text-gray-600 mt-1">{sub}</p>}
    </div>
  );
}
